import { useState, useCallback } from 'react';

const MAX_PLAYERS = 10;

export function usePlayers() {
  const [players, setPlayers] = useState<string[]>([]);

  const addPlayer = useCallback((name: string) => {
    const trimmed = name.trim();
    if (trimmed && players.length < MAX_PLAYERS && !players.includes(trimmed)) {
      setPlayers(prev => [...prev, trimmed]);
      return true;
    }
    return false;
  }, [players]);

  const removePlayer = useCallback((index: number) => {
    setPlayers(prev => prev.filter((_, i) => i !== index));
  }, []);

  const shufflePlayers = useCallback(() => {
    setPlayers(prev => {
      const shuffled = [...prev];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    });
  }, []);

  return {
    players,
    addPlayer,
    removePlayer,
    shufflePlayers,
    canAddMore: players.length < MAX_PLAYERS,
    hasEnoughPlayers: players.length >= 2,
  };
}
